<template>
    <div class="note">
        <Spinner v-if="loading" />
        <div v-if="localPartIndex >= 0" class="note__text">
            <div class="text__entity-wrap">
                <span
                    class="text__entity"
                    :class="{
                        'is-active': isActive
                    }"
                    @click.prevent="select(note.book_part.id, note.id)"
                >
                    {{ note.book_part_v2.raw_text }}
                </span>
            </div>
        </div>
        <div v-if="isReviewer && localPartIndex >= 0" class="note__player">
            <PlayerSimple class="player--round" :src="note.book_part_v2.audio" />
        </div>
        <div class="note__bottom">
            <NotesComment :text="note.comment" />
            <div v-if="isReviewer || isAdmin" class="note__add">
                <NotesEdit :note="note" @saved="onNotesSaved" />
                <NotesDelete :note="note" @delete="onNotesDeleted" />
            </div>
        </div>
    </div>
</template>

<script>
import { PlayerSimple } from '@speechki-frontend/shared/ui/Player';
import NotesEdit from '../NotesEdit/NotesEdit';
import NotesDelete from '../NotesDelete/NotesDelete';
import NotesComment from '../NotesComment/NotesComment';

import { mapGetters, mapState } from 'vuex';

export default {
    name: 'NotesListItem',
    components: {
        PlayerSimple,
        NotesEdit,
        NotesDelete,
        NotesComment
    },
    props: {
        note: {
            type: Object,
            required: true
        },
        isActive: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false
        };
    },
    computed: {
        ...mapGetters(['isAdmin']),
        ...mapState({
            book: state => state.book.book,
            user: state => state.auth.user
        }),

        isReviewer() {
            return this.book.reviewers.includes(this.user.pk);
        }
    },
    methods: {
        select(id, noteId) {
            this.$emit('selected', {
                id,
                index: this.localPartIndex,
                localId: this.note.local_id,
                immutable: false,
                note: noteId
            });
        },
        onNotesSaved(note) {
            this.$emit('saved', note);
        },
        onNotesDeleted(id) {
            this.$emit('deleted', id);
        }
    }
};
</script>

<style src="./NotesListItem.scss" lang="scss"></style>
